/* eslint-disable */
require('./big-dot')
require('./check')
require('./dot')
require('./oval')
